/* @flow */
import { DateTime } from 'luxon';
import { getEventId } from '@braindate/domain/lib/event/util';

import * as authenticationTypes from 'src/shared/app/authentication/action/base/authenticationActionTypes';
import * as entititesTypes from 'src/shared/domain/base/action/entityActionTypes';
import * as types from 'src/shared/domain/event/action/eventActionTypes';
import {
  topicOneOnOneKind,
  topicGroupKind,
  topicFishbowlKind,
} from '@braindate/domain/lib/topic/setting';
import {
  createReducer,
  patchEntities,
} from 'src/shared/core/util/reducerUtils';

import type { TopicKind } from '@braindate/domain/lib/topic/type';
import type {
  TimeSlot,
  TimeSlotSuggestion,
} from '@braindate/domain/lib/base/type';

const initialState = {};

const _updateEventData = (
  state: Object,
  action: {
    result: TimeSlotSuggestion[],
    topicKind: TopicKind,
    eventId: number,
    dateInterval: TimeSlot,
  },
  key: string,
) => {
  const { eventId, result, dateInterval } = action;

  const event = state[eventId];

  const dateTime = DateTime.fromISO(dateInterval.start_time).toLocal();

  return {
    ...state,
    [`${eventId}`]: {
      ...event,
      [key]: {
        ...event[key],
        [dateTime.toFormat('yyyy-MM-dd')]: result,
      },
    },
  };
};

const _updateSlotSuggestions = (
  state: Object,
  action: {
    result: TimeSlotSuggestion[],
    topicKind: TopicKind,
    eventId: number,
    month: string,
    dateInterval: TimeSlot,
  },
) => {
  const { topicKind } = action;

  const keys = {
    [topicOneOnOneKind]: 'offer_time_slots_suggestions',
    [topicGroupKind]: 'group_braindate_time_slots_suggestions',
    [topicFishbowlKind]: 'fishbowl_time_slots_suggestions',
  };

  return _updateEventData(state, action, keys[topicKind]);
};

const _patch = (state: Object, action: Object) =>
  patchEntities(state, action, 'events');

const _clean = (state: Object, action: Object) => {
  const { result: id } = action;

  return {
    ...state,
    [id]: null,
  };
};

const handleAuthSuccess = (state: Object, { event }: Object) => ({
  ...state,
  [getEventId(event)]: event,
});

export default createReducer(initialState, {
  [types.FETCH_TIME_SLOTS_SUGGESTIONS_SUCCESS]: _updateSlotSuggestions,
  [entititesTypes.PATCH_ENTITIES]: _patch,
  [types.FETCH_PUBLIC_EVENT_SUCCESS]: _clean,
  [authenticationTypes.LOGIN_SUCCESS]: handleAuthSuccess,
  [authenticationTypes.CREATE_PASSWORD_SUCCESS]: handleAuthSuccess,
});
